import { useMemo } from "react"
import { Operation } from "../../../../operations"
import { DeliveryOrder } from "../../../state/types"
import { DeliveryStatsTable } from "../../delivery-stats-table/deliveryStatsTable"

type Props = {
    deliveryOrder: DeliveryOrder
    operation: Operation
    title?: string
}

export const DeliveryOrderItemsStatsTable = (props: Props) => {
    const { deliveryOrder, operation, title } = props

    const rows = useMemo(() => deliveryOrder.items.map(item => ({
        itemId: item.itemId,
        quantity: item.quantity,
        pending: item.deliveryStats.pending,
        dispatched: item.deliveryStats.dispatched,
        delivered: item.deliveryStats.delivered,
        cancelled: item.deliveryStats.cancelled || 0,
        returned: item.deliveryStats.returned || 0
    })), [deliveryOrder.items])

    return (
        <DeliveryStatsTable
            deliveryMethod={deliveryOrder.method}
            title={title}
            items={rows}
            operation={operation}
        />
    )
}
